import { ChevronLeft } from "lucide-react";
import StrikeZone from "../StrikeZone";
import { PlayerSelector } from "../PlayerSelector";
import PitchInput from "../PitchInput";
import { BullpenPitchCounter } from "../PitchCounter";
import PitchTable from "../../tables/PitchTable";

export const BullpenChartSection = ({
  onBack,
  pitcher,
  pitches,
  currentPitch,
  shouldResetPlot,
  isPitcherView,
  zoneType,
  onPlayerEdit,
  onPitchChange,
  onSubmitPitch,
  onResetPitch,
  onToggleView,
  onPlotPitch,
  onDeletePitch,
  onUpdatePitch,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
      <div className="w-full mb-6">
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-gray-600 hover:text-blue-600"
        >
          <ChevronLeft size={20} />
          <span>Back to Charts</span>
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12 w-full">
        <div className="space-y-6">
          <div className="space-y-4">
            <PlayerSelector
              type="Pitcher"
              player={pitcher}
              onEdit={() => onPlayerEdit("pitcher")}
              required
            />
          </div>

          <PitchInput
            currentPitch={currentPitch}
            onChange={onPitchChange}
            onSubmit={onSubmitPitch}
            onReset={onResetPitch}
            disabled={!pitcher}
            isBullpen={true}
            zoneType={zoneType}
          />
        </div>
        <div className="flex items-center justify-center bg-white rounded-lg shadow-sm border border-gray-200 p-6 relative">
          <div className="absolute top-4 right-4 z-10">
            <button
              onClick={onToggleView}
              className="flex items-center gap-2 px-3 py-1.5 bg-white rounded-md shadow-sm
                border border-gray-200 text-sm font-medium text-gray-700
                hover:bg-gray-50 transition-colors"
            >
              Toggle View
            </button>
          </div>
          <BullpenPitchCounter pitches={pitches} />
          <StrikeZone
            key={isPitcherView ? "pitcher" : "catcher"}
            onPlotPitch={onPlotPitch}
            pitches={pitches}
            currentPitch={currentPitch}
            shouldReset={shouldResetPlot}
            isBullpen={true}
            isPitcherView={isPitcherView}
            zoneType={zoneType}
          />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800">Pitch History</h2>
        </div>
        <div className="w-full max-w-full">
          <PitchTable
            pitches={pitches}
            onDeletePitch={onDeletePitch}
            onUpdatePitch={onUpdatePitch}
            isBullpen={true}
            zoneType={zoneType}
          />
        </div>
      </div>
    </div>
  );
};
